import angular from 'angular';
import moment from 'moment';

angular.module('cloudX').directive('cxDateScroller', [
  function() {
    return {
      restrict: 'E',
      replace: 'true',
      template: require('./dateScroller.html'),
      require: '^ngModel',
      scope: true,
      link: function(scope, element, attrs, ctrl) {
        var ngModel = ctrl;

        ngModel.$render = function() {
          scope.date = ngModel.$viewValue || new Date();
          if (typeof scope.date === 'string') scope.date = new moment(scope.date).toDate();
          if (!(scope.date instanceof Date)) scope.date = new Date();
          scope.date = moment(scope.date)
            .clone()
            .toDate();
        };

        scope.onChange = function() {
          ngModel.$setViewValue(scope.date);
        };

        scope.update = function(n) {
          scope.date = new Date(scope.date); //Watch didn't detect addDays changes
          scope.date = moment(scope.date)
            .add(n, 'days')
            .toDate();
          ngModel.$setViewValue(scope.date);
        };
      },
    };
  },
]);
